declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { HCPService } from '../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController, ActorContactInfoController, ActorContactInfoRequest } from '../../../models/profileinfo/profileinfo.model';
import { ActorImageController, OTFormsByFormattedCodeController, OTFormDetailByReportCodeRequest, OTFormsByFormattedCodeRequest, OTFormDetailByReportCodeController, SectionData, FormOrganizer, X_BillHeaderController, x_BillDetailsRequest, BillDetailsInfoController, X_BillItemsController, X_BillReceiptsController, GenerateIahOrderFromBillRequest, AdmissionsListController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, BillAdvancesListController, BillAdvancesListRequest, NewBillData, DoctorsListController, DoctorsListRequest, GenericProcPostRequest, GenericParams, AdmissionsHeader2, S_Methods, FTV } from '../../../models/actor/actor';
//import { NgxMaskModule } from 'ngx-mask';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../services/datetime.service';
//import './profilesteps.js';
//declare var mess1: any;
//declare var stepObject: any;
//declare var pSteps: any;
//declare var webGlObject: any;

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';


import { PrintService } from '../../../../../../src/app/ncs/services/print.service';


import { NgxSpinnerService } from 'ngx-spinner';
import { NgbAddbilladv } from '../opbilling/modal/addbilladv.modal';
import { NgbPaymentModal } from '../opbilling/modal/payment.modal';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';

@Component({
  selector: 'billadmission',
  templateUrl: './billadmission.component.html',
  styleUrls: ['./billadmission.component.scss']
})

export class BillAdmissionComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() FormattedCode: string;
  @Input() AdmissionCode: string;
  @Input() AdmissionDate: Date;
  @Input() ProviderIncharge: string;
  @Input() AdmissionCode2: number;
  @Input() RefDet: string;
  @Input() RefDoc: string;
  @Input() Admission: AdmissionsListController;
  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() PatientCode: number;
  @Input() FacilityCode: number;
  public Prescribername: any;
  public Prescribercode: number = 0;
  public Prescriberdesg: any;
  public Refname: any = "";
  public Refcode: number = 0;
  public Refdesg: any = "";
  public isRequesting: boolean = false;
  public TotalAdvance: number;
  public BillsList: boolean = false;
  public BillsDetails: boolean = false;
  public ApiResData: ApiResponseModel;
  public Tdiscount: number;
  public MaxDateV = new Date();
  public MinDateV = new Date();
  public PatientFormattedCode: string;
  public PatientName: string;
  public PayeeName: string;
  public Toatalbill: number;
  public PaidBill: number;
  public BillNumber: any;
  DOB: NgbDateStruct;

  CurrentGenerateIahOrderFromBillRequest: GenerateIahOrderFromBillRequest;

  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  //
  public key: ActorPersonalDetailInfoController;


  @Input()
  get Key() {
    return this.key;
  }

  @Output() personalInfoChange = new EventEmitter();
  public ChargeEntryCode: number;
  CurrentBillDetailsInfoController: X_BillHeaderController[];
  Currentx_BillDetailsRequest: x_BillDetailsRequest;

  LoadForms() {
    this.Currentx_BillDetailsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.Currentx_BillDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentBillDetailsInfoController;
    this.GetBillDetailsInfoController();
  }
  GetBillDetailsInfoController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date();
    this.Currentx_BillDetailsRequest.ToDate = new Date();
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 9;
    this.Currentx_BillDetailsRequest.ActorCode = this.ActorCode;
    this.Currentx_BillDetailsRequest.BillType = 'OPBILL';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    this.Currentx_BillDetailsRequest.SearchText = '';

    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          //this.TotalAdvance = this.CurrentBillDetailsInfoController.filter(l => l.TotalAmount)
          //    .reduce((sum, current) => sum + current.TotalAmount, 0);
          //this.ChargeEntryCode = this.CurrentBillDetailsInfoController[0].ChargeEntry;

          //this.pdata = this.CurrentBillDetailsInfoController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    // alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          this.LoadAdvances();
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentBillAdvancesListController: BillAdvancesListController[];
  AdvanceList: BillAdvancesListController[];
  CurrentBillAdvancesListRequest: BillAdvancesListRequest;



  LoadAdvances() {
    this.CurrentBillAdvancesListRequest = new BillAdvancesListRequest();
    this.CurrentBillAdvancesListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentBillAdvancesListRequest.ConditionalOperator = 20;
    this.CurrentBillAdvancesListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentBillAdvancesListRequest.AdmissionCode = this.AdmissionCode2;
    this.GetBillAdvancesListController();
  }
  GetBillAdvancesListController() {
    this.StartRefreshing();


    this.actorservice.GetBillAdvancesListController(this.CurrentBillAdvancesListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentBillAdvancesListController = this.ApiResData.Result;
          this.TotalAdvance = this.CurrentBillAdvancesListController.filter(l => l.AdvanceAmount)
            .reduce((sum, current) => sum + current.AdvanceAmount, 0);
          //this.AdvanceList = this.CurrentBillAdvancesListController.filter(function (v, i, d) {
          //    return v.ReceiptDate. == AdmissionDate 
          //});
          //alert(this.AdvanceList.length)

          //this.ChargeEntryCode = this.CurrentBillDetailsInfoController[0].ChargeEntry;

          //this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private spinner: NgxSpinnerService, private tosterservice: NGXToastrService) {
    //stepObject.init();
  }

  ngOnInit() {
    this.Tdiscount = 0;
    this.PatientFormattedCode = this.FormattedCode;
    this.CurrentGenerateIahOrderFromBillRequest = new GenerateIahOrderFromBillRequest();
    this.CurrentGenerateIahOrderFromBillRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadDetailedAdmissionData();
    this.LoadPatients();
    this.LoadForms();
    //this.LoadBillHeader();
    this.LoadBillItems();
  }

  //ViewPatientDetails() {
  //    this.BillsList = false;
  //    this.BillsDetails = true;
  //    this.LoadBillHeader();
  //    this.LoadBillItems();
  //    this.LoadBillReceipts();
  //}
  SelectedpatientDetails: X_BillHeaderController;
  Selectedpatient(objCategory: any) {
    var patient: X_BillHeaderController = objCategory;
    if (patient != null) {
      //alert(patient.ChargeEntry);
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = patient;
      this.BillsList = false;
      this.BillsDetails = true;
      // this.billdetails1 = true;
      //this.billdetails2 = true;
      //this.LoadBillReceipts();
    }


  }
  AdmissionHeader2: AdmissionsHeader2;
  LoadDetailedAdmissionData() {
    /// 101029
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var getReq: GenericParams = new GenericParams();
    getReq.ConditionalOperator = 101029;
    getReq.Params = [
      new FTV('AdmissionNo', 'number', this.AdmissionCode2)
    ];
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101029;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          this.AdmissionHeader2 = JSON.parse(data)[0];
          //alert(this.AdmissionHeader2);
          //alert(this.AdmissionHeader2.IsDischargeInitiated);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  EditBill() {
    this.router.navigate(['healins/IPreceiptedit_svcprovider', {
      FormattedCodedata: this.FormattedCode,
      AdmissionCodedata: this.AdmissionCode2,
      FacilityCodedata: this.FacilityCode,
      ChargeEntryCode: this.AdmissionHeader2.ChargeEntry,
      //BillStatus: this.CurrentX_BillHeaderController.BillStatus
    }]);
  }

  CurrentX_BillHeaderController: X_BillHeaderController;
  //FollicularScanEndInfo: FollicularScanDetailController;
  // BillHeader: X_BillHeaderController[];
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    //alert("ScansData")
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    //this.StartRefreshing();

    this.CurrentX_BillHeaderRequest.ChargeEntry = 0;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillHeaderRequest.AdmissionCode = this.AdmissionCode2;
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 40;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          //this.BillNumber = this.CurrentX_BillHeaderController.BillNo;
          //this.CurrentX_BillItemsController = this.BillDataHeader.Items;
          //alert(this.CurrentX_BillHeaderController[0].PatientName);
          //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillItemsController: X_BillItemsController[];
  BillItems: X_BillItemsController;
  //FollicularScanEndInfo: FollicularScanDetailController;
  //BillHeader: X_BillHeaderController[];
  CurrentX_BillItemsRequest: x_BillDetailsRequest;

  BillData: BillDetailsInfoController;

  LoadBillItems() {
    //alert("ScansData")
    this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillItemsController();
  }

  GetX_BillItemsController() {
    //this.StartRefreshing();

    this.CurrentX_BillItemsRequest.ChargeEntry = 0;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillItemsRequest.AdmissionCode = this.AdmissionCode2;
    this.CurrentX_BillItemsRequest.ConditionalOperator = 40;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillItemsController(this.CurrentX_BillItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillData = this.ApiResData.Result;
          if (this.BillData) {
            this.CurrentX_BillHeaderController = this.BillData.Header;
            this.CurrentX_BillItemsController = this.BillData.Items;
            this.BillNumber = this.BillData.Header?.BillNo || '';
          }
          this.LoadDoctorsList();
          //this.AddData3();

          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    // this.pdata = this.CurrentDoctorsListController;
    //this.pdata1 = this.CurrentDoctorsListController;
    this.CurrentDoctorsListRequest.ConditionalOperator = 20;
    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {


          this.CurrentDoctorsListController = this.ApiResData.Result;

          if (this.ProviderIncharge != 'null') {
            this.Prescribercode = 0;
            this.Prescriberdesg = '';
            this.Prescribername = this.ProviderIncharge;
            this.LoadDoctorPres();
          }
          if (this.RefDoc != 'null') {
            this.Refname = this.RefDoc;
            this.Refcode = 0;
            this.Refdesg = "null";
            this.LoadDoctorRef();
            //this.Refcode = this.CurrentDoctorsListController.filter(X => X.Prefix.concat(X.DisplayName) == this.RefDoc)[0].ProviderCode;
            //this.Refdesg = this.CurrentDoctorsListController.filter(X => X.Prefix.concat(X.DisplayName) == this.RefDoc)[0].Specialty; 

          }
          if (this.RefDoc == 'null') {

            this.Refcode = 0;
            this.Refdesg = "null";
            this.Refname = "null";
            this.LoadDoctorRef();
          }

          //this.pdata = this.CurrentDoctorsListController;
          //this.pdata1 = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentPrescribingDoctor: Array<PrescribingDoctor>;
  LoadDoctorPres() {
    // alert(Selectedgroupnew.DoctorName + "," + Selectedgroupnew.DoctorCode);
    if (this.CurrentPrescribingDoctor == null) {
      this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();
    }
    if (this.CurrentPrescribingDoctor != null) {
      var row = new PrescribingDoctor();
      row.DoctorName = this.Prescribername;
      row.DoctorCode = this.Prescribercode;
      row.Designation = this.Prescriberdesg;
      //row.DoctorName = Selectedgroupnew.DoctorName;
      // row.DoctorCode = Selectedgroupnew.DoctorCode;
      // row.Designation = Selectedgroupnew.Designation;
      this.CurrentPrescribingDoctor.push(row);
    }
  }

  CurrentReferringDoctor: Array<ReferringDoctor>;

  LoadDoctorRef() {
    if (this.CurrentReferringDoctor == null) {
      this.CurrentReferringDoctor = new Array<ReferringDoctor>();
    }
    if (this.CurrentReferringDoctor != null) {
      var row = new ReferringDoctor();
      row.DoctorName = this.Refname;
      row.DoctorCode = this.Refcode;
      row.Designation = this.Refdesg;
      this.CurrentReferringDoctor.push(row);
    }
  }
  CurrentBillDetails: Array<BillDetails>;
  AddData3() {
    this.CurrentBillDetails = new Array<BillDetails>();
    this.CurrentX_BillItemsController.forEach((v, i, d) => {
      var item = new BillDetails();
      item.Edit = false;
      item.RowNumber = item.RowNumber + 1;
      item.ServiceDescription = v.ItemDescription;
      item.Quantity = v.Quantity;
      item.Discount = v.Discount;
      item.UnitPrice = v.UnitPrice;
      item.ItemRate = v.ItemTotal;
      item.GroupName = v.ServiceCategory.toString();
      item.PackageName = v.ServiceCategoryName;
      item.DiscountAllowed = false;
      item.ChargeItemCode = 0;
      item.ItemCode = v.ItemCode;
      this.CurrentBillDetails.push(item);


    });
    this.AddData();
  }

  CurrentNewBillData: NewBillData;
  AddData() {
    this.Tdiscount = this.CurrentX_BillHeaderController.Discount;
    this.CurrentNewBillData = new NewBillData();
    this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;
    this.CurrentNewBillData.BillDate = new Date();
    this.CurrentNewBillData.BillSource = "Internal";
    this.CurrentNewBillData.BillStatus = "";
    this.CurrentNewBillData.BillType = "IP";
    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
    this.CurrentNewBillData.ChargeEntryCode = this.CurrentX_BillHeaderController.ChargeEntry;
    this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
    this.CurrentNewBillData.Items = this.CurrentBillDetails;

    this.CurrentNewBillData.PrescriberDoctor = this.CurrentPrescribingDoctor;
    this.CurrentNewBillData.ReferringDoctor = this.CurrentReferringDoctor;
    this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
    this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
    this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
    this.CurrentNewBillData.TotalDiscount = this.Tdiscount;
    this.CurrentNewBillData.PreviousDiscount = 0;
    this.CurrentNewBillData.DiscountAmount = 0;
    this.CurrentNewBillData.DiscountRemarks = "";
    this.CurrentNewBillData.Discountmode = "";
    this.CurrentNewBillData.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current);
    this.CurrentNewBillData.NetPayable = this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current) - this.Tdiscount;
    this.CurrentNewBillData.AdmissionFormattedCode = this.AdmissionCode;
    this.CurrentNewBillData.AdmissionCode = this.AdmissionCode2;
    this.Payment();
    //this.CurrentNewBillData
    // this.SaveData();


  }
  Payment() {
    const modalRef = this.modalService.open(NgbPaymentModal,
      {
        centered: true,
        size: "lg"

      })
    modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
    modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
    modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
    modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
    modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
    modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
    modalRef.componentInstance.BillDate = this.CurrentNewBillData.BillDate;
    modalRef.componentInstance.TotalBill = this.CurrentNewBillData.TotalBill;
    modalRef.componentInstance.NetPayable = this.CurrentNewBillData.NetPayable;
    modalRef.componentInstance.Discount = this.CurrentNewBillData.TotalDiscount;
    modalRef.componentInstance.ActorCode = this.CurrentNewBillData.ActorCode;
    modalRef.componentInstance.ChargeEntryCode = this.CurrentX_BillHeaderController.ChargeEntry;
    modalRef.componentInstance.BillStatus = this.CurrentNewBillData.BillStatus;
    modalRef.componentInstance.BillType = this.CurrentNewBillData.BillType;
    modalRef.componentInstance.BillType2 = "IP";
    modalRef.componentInstance.BillSource = this.CurrentNewBillData.BillSource;
    modalRef.componentInstance.BranchName = this.CurrentNewBillData.BranchName;
    modalRef.componentInstance.BranchCode = this.CurrentNewBillData.BranchCode;
    modalRef.componentInstance.PatientCode = this.CurrentPatientInfoByFormattedCodeController[0].PatientRegistrationNumber;
    modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;
    modalRef.componentInstance.BillStatus2 = 'New';
    modalRef.componentInstance.DiscountMode = "";
    modalRef.componentInstance.PreviousDiscount = 0;
    modalRef.componentInstance.Discountre = "";
    modalRef.componentInstance.Prescriber = this.CurrentPrescribingDoctor;
    modalRef.componentInstance.Refferal = this.CurrentReferringDoctor;
    modalRef.componentInstance.Data = 'Full';
    modalRef.componentInstance.AdmissionFormattedCode = this.AdmissionCode;
    modalRef.componentInstance.AdmissionCode = this.AdmissionCode2;
    //modalRef.result.then((val: number) => {
    //  this.ChargeEntryCodeModal = val;
    //  if (val > 0 && this.DiscountMode == 'Bill Level') {
    //    this.LoadBillHeader(val);
    //  }
    //});

  }
  //header() {
  //    let m = document.querySelector("#header");
  //    if (m) {
  //        m.scrollIntoView({ block: "center", inline: "nearest" });
  //    }
  //}
  items() {
    let m = document.querySelector("#items");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Receipts() {
    let m = document.querySelector("#Receipts");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  BackToBillsList() {
    this.BillsList = true;
    this.BillsDetails = false;
  }
  billedit() {

    this.router.navigate(['healins/opbillingedit', { FormattedCodedata: this.FormattedCode }]);
  }
  AddNewBill() {

    this.router.navigate(['healins/receipt']);
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  ConvertToIah() {
    //alert("Code");
    this.CurrentGenerateIahOrderFromBillRequest.ConditionalOperator = 10;
    this.CurrentGenerateIahOrderFromBillRequest.ChargeEntryCode = this.SelectedpatientDetails.ChargeEntry;
    this.actorservice.GenerateIahOrderFromBill(this.CurrentGenerateIahOrderFromBillRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            // this.Listview = true;
            //this.EditEmbryo = false;
            //this.LoadStoreData();
            //this.AddEmbryo = false;
            //this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();
            this.router.navigate(['healins/ConsumptionEntry']);
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            //this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            //this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }
  
  admnadvbill() {
    this.printService.printDocument2(this.FormattedCode, 0

    );
    this.printService.printDocument3(this.FormattedCode, 0

    );
    this.printService.printDocument("admadvancebill",
      {
        PatientCode: this.SelectedPatientFormattedCode.PatientRegistrationNumber, PatientId: this.FormattedCode,
        AdmissionCode: this.AdmissionCode2,
      },

    );
  }
  admnitemwisebill() {
    this.printService.printDocument2(this.FormattedCode, 0

    );
    this.printService.printDocument3(this.BillNumber, 0

    );
    this.printService.printDocument("admitemwisebill",
      {
        PatientCode: this.SelectedPatientFormattedCode.PatientRegistrationNumber, PatientId: this.FormattedCode,
        AdmissionCode: this.AdmissionCode2,

      },

    );
  }
  SelectAdvance(l: BillAdvancesListController) {
    this.printService.printDocument2(this.FormattedCode, 0

    );
    this.printService.printDocument3(this.FormattedCode, 0

    );
    this.printService.printDocument("admadvancebillindi",
      {
        PatientCode: this.SelectedPatientFormattedCode.PatientRegistrationNumber, PatientId: this.FormattedCode,
        AdmissionCode: this.AdmissionCode2, Date: l.BillDate, Mode: l.PaymentInstrument, AdAmount: l.AdvanceAmount

      },

    );
  }
  admnbillsummary() {
    this.printService.printDocument2(this.FormattedCode, 0

    );
    this.printService.printDocument3(this.BillNumber, 0

    );
    this.printService.printDocument("admbillsummary",
      {
        PatientCode: this.SelectedPatientFormattedCode.PatientRegistrationNumber, PatientId: this.FormattedCode,
        AdmissionCode: this.AdmissionCode2,

      },

    );
  }

  EditIp() {
    this.router.navigate(['healins/ipreceipt', { FormattedCode: this.FormattedCode, AdmissionCode: this.AdmissionCode, AdmissionDate: new Date(this.AdmissionDate), Incharge: this.ProviderIncharge, AdmissionCode2: this.AdmissionCode2, RefDet: this.RefDet, RefDoc: this.RefDoc, SelectedAdmissionString: JSON.stringify(this.Admission) }]);
  }
  Addbill() {
    this.router.navigate(['healins/receiptold', { FormattedCode: this.FormattedCode }]);
  }
  AddAdv() {
    const modalRef = this.modalService.open(NgbAddbilladv,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.FomattedCode = this.FormattedCode;
    modalRef.componentInstance.Type = "IpAdvance"
    //modalRef.componentInstance.ChargeEntry = this.CurrentBillDetailsInfoController[0].ChargeEntry;
    modalRef.componentInstance.AdmissionCode = this.AdmissionCode;
    modalRef.componentInstance.AdmissionCode2 = this.AdmissionCode2;
    modalRef.result.then(x => { this.GetBillAdvancesListController() })
  }
}

//export class BillDetails {
//  public ItemCode: number;
//  public ServiceDescription: string;
//  public Quantity: number;
//  public UnitPrice: number;
//  public Discount: number;
//  public ItemRate: number;
//  public RowNumber: number;
//  public Edit: boolean;
//  public ServiceCode: number;
//  public ItemType: string;
//  public ItemGroup: string;
//  public GroupName: string;
//  public IsPackage: boolean;
//  public PackageName: string;
//  public ChargeItemCode: number;
//  public DiscountAllowed: boolean;
//  public rDiscount: number;
//  public CanModify: boolean;
//  public IsDeleted: boolean = false;  // editing purposes only... 
//  public EditableCharge: boolean;
//  public RefundableAmount: number;
//  public RefundableQuantity: number;
//  public TaxPercentage: number;
//}

//export class BillItemDeleted {

//  public ChargeItemCode: number;
//}

//export class PrescribingDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}
//export class ReferringDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}
